import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App";
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdAddCircle, IoMdAnalytics, IoMdBriefcase, IoMdBulb, IoMdCheckmarkCircleOutline, IoMdCodeWorking, IoMdEye, IoMdFolder, IoMdGitBranch, IoMdGlobe, IoMdLaptop, IoMdPeople, IoMdPie, IoMdRefresh, IoMdRibbon, IoMdRocket, IoMdSchool, IoMdStar, IoMdStats } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheckCircle, MdChildCare, MdFavorite, MdFemale, MdHealthAndSafety, MdHome, MdLightMode, MdLocationPin, MdOutlineAssessment, MdOutlineSavings, MdSearch, MdVerified } from "react-icons/md";

import logo from '../assets/logo_icon.png';
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneObjective from "./OneObjective";
import HomeSlider from "./HomeSlider";
import HomeBanner1 from "./HomeBanner1";
import HomeBanner3 from "./HomeBanner3";
import AboutCompany from "./AboutCompany";
import CustomersHighlight from "./CustomersHighlight";

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>

				<div 
					className="MainBodySection"
				>
					<div className="container">
						<div className="row">
							<h3 className="main-section-title">
								About us
							</h3>
						</div>
					</div>
				</div>

				<AboutCompany/>

				<HomeBanner3/>

				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "45px",
						paddingTop: "45px"
					}}
				>
					<div className="container">
						<div className="row">

							<div 
								className="col-md-4 text-center mb-3 mt-3"
								style={{
									display: "grid",
									placeItems: "center"
								}}
							>
								<img
									src={logo} height={200}
								/>
							</div>

							<div className="col-md-4 mt-3 mb-3 px-5">
								
								<h3 
									className="text-primary font-bold"
									
								>
									Mission:
								</h3>

								<p
									style={{
										textAlign:"justify"
									}}
								>
									To achieve the reputation of a quality, high standard & reliable solution & service Provider Company in the ICT industry.
								</p>
								
							</div>

							<div className="col-md-4 mt-3 mb-3 px-5">

								<h3 
									className="text-primary font-bold"
									
								>
									Vision:
								</h3>

								<p
									style={{
										textAlign:"justify"
									}}
								>
								 To achieve 100% customer satisfaction by delivering quality products and services at an affordable cost. Our forward vision is to strive to become an entity in technology based corporate solutions, capable of demanding unconditional response from the targeted niche.
								</p>

							</div>

						</div>
					</div>
				</div>
				
				<CustomersHighlight/>
				<HomeBanner1/>

				<div className="main-body-section">
					<div className="container py-5">
						<div className="row">

							<div className="col-md-6 mt-3">
								<h2 className="text-primary font-semi-bold mb-3">
									Our Keys for Development
								</h2>
								<ul className="list-unstyled">
									<li className="d-flex align-items-start mb-3">
									<IoMdStar size={24} className="text-secondary me-2 flex-shrink-0" />
									<span>Desire for Excellence</span>
									</li>
									<li className="d-flex align-items-start mb-3">
									<IoMdEye size={24} className="text-secondary me-2 flex-shrink-0" />
									<span>Trust and Confidence Build-up</span>
									</li>
									<li className="d-flex align-items-start mb-3">
									<IoMdBulb size={24} className="text-secondary me-2 flex-shrink-0" />
									<span>Innovation</span>
									</li>
									<li className="d-flex align-items-start mb-3">
									<IoMdEye size={24} className="text-secondary me-2 flex-shrink-0" />
									<span>Transparency</span>
									</li>
									<li className="d-flex align-items-start mb-3">
									<IoMdPeople size={24} className="text-secondary me-2 flex-shrink-0" />
									<span>Teamwork</span>
									</li>
								</ul>
							</div>

							<div className="col-md-6 mt-3">
								<h2 className="text-primary font-semi-bold mb-3">We Believe In</h2>
								<ul className="list-unstyled">
									<li className="d-flex align-items-start mb-3">
									<IoMdRocket size={24} className="text-secondary me-2 flex-shrink-0" />
									<span>Motivation</span>
									</li>
									<li className="d-flex align-items-start mb-3">
									<IoMdGitBranch size={24} className="text-secondary me-2 flex-shrink-0" />
									<span>Collective Responsibility and Leadership</span>
									</li>
									<li className="d-flex align-items-start mb-3">
									<IoMdRibbon size={24} className="text-secondary me-2 flex-shrink-0" />
									<span>Professionalism and Ethics</span>
									</li>
									<li className="d-flex align-items-start mb-3">
									<IoMdAddCircle size={24} className="text-secondary me-2 flex-shrink-0" />
									<span>Adding Values to Our Client Needs</span>
									</li>
									<li className="d-flex align-items-start mb-3">
									<IoMdGlobe size={24} className="text-secondary me-2 flex-shrink-0" />
									<span>Closely Working to Establish Business in Other Regions</span>
									</li>
								</ul>
							</div>
							
						</div>
					</div>
				</div>

				<div className="main-body-section bg-surface">
					<div className="container py-5">
						<div className="row">

						<div className="col-md-12">
							<h6 className="main-section-title font-bold mt-5 mb-3">
								Strengths & Capabilities
							</h6>

							<h5 className="text-muted mb-3">
								The development team of BOSTON is equipped with proper human resources specialized in different system development tasks. The key areas are;
							</h5>

							<div className="row">

							<div className="col-md-12 d-flex align-items-center bg-background rounded mt-3">
								<div className="row">
								<div
									style={{ borderRight: "1px solid var(--dimColor)" }}
									className="col-md-3 d-flex flex-column align-items-center gap-1 p-3"
								>
									<IoMdPie size={48} className="text-primary"/>
									<h6 className="text-dim text-center">System Analysis & Design</h6>
								</div>
								<hr className="mMobileOnly" />
								<div className="col-md-9 d-flex align-items-center justify-content-center">
									<h5>
									Combining functional and technical analysis to develop proper systems using tools like Microsoft Visio, Rational Rose, and Visual Modeler.
									</h5>
								</div>
								</div>
							</div>

							{/* 2. Source Code Repository & Administration */}
							<div className="col-md-12 d-flex align-items-center bg-background rounded mt-3">
								<div className="row">
								<div
									style={{ borderRight: "1px solid var(--dimColor)" }}
									className="col-md-3 d-flex flex-column align-items-center gap-1 p-3"
								>
									<IoMdFolder size={48} className="text-primary"/>
									<h6 className="text-dim text-center">Source Code Repository & Administration</h6>
								</div>
								<hr className="mMobileOnly" />
								<div className="col-md-9 d-flex align-items-center pb-2">
									<h5>
									Managing source code version control and multi-programmer collaboration using Visual Source Safe.
									</h5>
								</div>
								</div>
							</div>

							{/* 3. Database Management */}
							<div className="col-md-12 d-flex align-items-center bg-background rounded mt-3">
								<div className="row">
								<div
									style={{ borderRight: "1px solid var(--dimColor)" }}
									className="col-md-3 d-flex flex-column align-items-center gap-1 p-3"
								>
									<IoMdStats size={48} className="text-primary"/>
									<h6 className="text-dim text-center">Database Management</h6>
								</div>
								<hr className="mMobileOnly" />
								<div className="col-md-9 d-flex align-items-center pb-2">
									<h5>
									Expertise ranging from Access and Visual FoxPro to Oracle, SQL Server, and MySQL for cross-platform data management.
									</h5>
								</div>
								</div>
							</div>

							{/* 4. Web Development & Design */}
							<div className="col-md-12 d-flex align-items-center bg-background rounded mt-3">
								<div className="row">
								<div
									style={{ borderRight: "1px solid var(--dimColor)" }}
									className="col-md-3 d-flex flex-column align-items-center gap-1 p-3"
								>
									<IoMdLaptop size={48} className="text-primary"/>
									<h6 className="text-dim text-center">Web Development & Design</h6>
								</div>
								<hr className="mMobileOnly" />
								<div className="col-md-9 d-flex align-items-center pb-2">
									<h5>
									Skilled in building websites using Microsoft Front Page, Macromedia Fireworks, and Dreamweaver for design and development.
									</h5>
								</div>
								</div>
							</div>

							{/* 5. Programming */}
							<div className="col-md-12 d-flex align-items-center bg-background rounded mt-3">
								<div className="row">
								<div
									style={{ borderRight: "1px solid var(--dimColor)" }}
									className="col-md-3 d-flex flex-column align-items-center gap-1 p-3"
								>
									<IoMdCodeWorking size={48} className="text-primary"/>
									<h6 className="text-dim text-center">Programming</h6>
								</div>
								<hr className="mMobileOnly" />
								<div className="col-md-9 d-flex align-items-center pb-2">
									<h5>
									Developing systems with VB, Visual C++, Java, VBA, .NET, PHP, ASP, scripting languages, and multimedia tools.
									</h5>
								</div>
								</div>
							</div>

							</div>
						</div>

						</div>
					</div>
					</div>


			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}